/*!
 * paths.js — where the playhead is on the screen
 * Part of oscillaScore modular architecture
 * © 2025 Rob Canning — GPLv3
 */

/**
 * The playhead's place along the scroll axis, in screen px from the score
 * container's edge: X in horizontal mode, Y in vertical mode. Screen px,
 * not world units (window.playheadX is world units): it is compared with
 * element rects, which are on the screen too.
 * @returns {number|null}
 */
export function playheadScreenX() {
  const playhead = document.getElementById("playhead");
  const scoreContainer = window.scoreContainer;
  if (!playhead || !scoreContainer) return null;

  const containerRect = scoreContainer.getBoundingClientRect();
  const playheadRect = playhead.getBoundingClientRect();

  if (window.scrollMode === "vertical") {
    return playheadRect.top - containerRect.top;
  }
  return playheadRect.left - containerRect.left;
}
